import { render, staticRenderFns } from "./SpecialRfDgDtlPop.vue?vue&type=template&id=521816a7"
import script from "./SpecialRfDgDtlPop.vue?vue&type=script&lang=js"
export * from "./SpecialRfDgDtlPop.vue?vue&type=script&lang=js"
import style0 from "./SpecialRfDgDtlPop.vue?vue&type=style&index=0&id=521816a7&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521816a7')) {
      api.createRecord('521816a7', component.options)
    } else {
      api.reload('521816a7', component.options)
    }
    module.hot.accept("./SpecialRfDgDtlPop.vue?vue&type=template&id=521816a7", function () {
      api.rerender('521816a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SpecialRfDgDtlPop.vue"
export default component.exports